import React from 'react';
import { useMediaQuery, useTheme } from '@material-ui/core';
import Modal from 'components/shared/Modal';

interface FilterModalProps {
  visible: boolean;
  onClose: () => void;
  onSave: () => void;
  title: string;
  description?: string;
  children: React.ReactNode;
  saveLabel?: string;
  requireSelection?: boolean;
  selectionCount?: number;
  wide?: boolean;
  footerLeft?: React.ReactNode;
}

const FilterModal = ({ visible, onClose, onSave, title, description, children, saveLabel = 'Apply', requireSelection = false, selectionCount = 0, wide = false, footerLeft }: FilterModalProps) => {
  const canSave = !requireSelection || selectionCount > 0;
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const buttons = (
    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
      <button
        onClick={onClose}
        style={{
          padding: isMobile ? '6px 14px' : '8px 20px',
          borderRadius: 8,
          border: '1px solid #ddd',
          backgroundColor: 'white',
          fontSize: 13,
          cursor: 'pointer',
          color: '#666',
        }}
      >
        Cancel
      </button>
      <button
        onClick={canSave ? onSave : undefined}
        disabled={!canSave}
        style={{
          padding: isMobile ? '6px 14px' : '8px 20px',
          borderRadius: 8,
          border: 'none',
          backgroundColor: canSave ? '#38566B' : '#ccc',
          color: 'white',
          fontSize: 13,
          fontWeight: 500,
          cursor: canSave ? 'pointer' : 'default',
          opacity: canSave ? 1 : 0.6,
        }}
      >
        {saveLabel}
      </button>
    </div>
  );

  return (
    <Modal visible={visible} close={onClose} customWidth={wide ? 720 : 500}>
      <div style={{ padding: '4px 0' }}>
        <div style={isMobile ? { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 } : undefined}>
          <div>
            <h2 style={{ fontSize: 20, fontWeight: 600, margin: '0 0 4px', color: '#333' }}>{title}</h2>
            {description && !isMobile && <p style={{ fontSize: 13, color: '#888', margin: '0 0 16px' }}>{description}</p>}
          </div>
          {isMobile && buttons}
        </div>

        <div style={isMobile ? { margin: '4px 0' } : { maxHeight: wide ? 'min(560px, 70vh)' : 'min(520px, 70vh)', overflowY: 'auto', margin: '12px -14px 12px 0', paddingRight: 14 }}>
          {children}
        </div>

        {!isMobile && (
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, paddingTop: 12, borderTop: '1px solid #eee' }}>
            {footerLeft}
            <div style={{ flex: 1 }} />
            {buttons}
          </div>
        )}
      </div>
    </Modal>
  );
};

export default FilterModal;
